import React from 'react'

import SelectLocOrg from '../../components/SelectLocOrg'
import LogoModal from '../../components/LogoModal'

import * as org from '../../services/organization-service'

export default class Topbar extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.getLogo = this.getLogo.bind(this)
    this.state = { 
      logo: "",
    }
  }

  componentDidMount() {
    this.getLogo()
  }

  uploadLogo(logo) {
    this.logoModal.handleShowmodal(logo)
  }

  getLogo() {
    org.getLogo().then((logo) => this.setState({logo: logo}))
  }

  render() {
    //TODO get the proper contenttype png or jpeg, (png seems to work even for jpeg's so this is ok for now)
    const logo = 'data:image/png;base64,' + this.state.logo

    return (
      <div id="topbar">
        <h1 className="page-title">{this.props.title}</h1>
        {this.props.select && (
          <SelectLocOrg
            location={this.props.location}
            locations={this.props.locations}
            disabled={this.props.disabled}
            unit={this.props.unit}
            units={this.props.units}
            unitChange={this.props.unitChange}
            locationChange={this.props.locationChange}
          />
        )}
        <div className="organisation-logo">
          <img src={logo} alt={"logo"} onClick={this.uploadLogo.bind(this)}/>
        </div>
        <LogoModal
          title="Logo van uw organisatie toevoegen"
          reload={() => this.getLogo()} 
          ref={ref => (this.logoModal = ref)}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Topbar/index.js